const playlistConfig = {
  sessionLimit: 100,
  playlistLimit: 50,
}

export default playlistConfig
